var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3122 20H10.2282V12.6875H7.63623V9.84375H10.2282V7.75C10.2282 7.13541 10.3211 6.59896 10.507 6.14062C10.693 5.67187 10.9527 5.27865 11.2863 4.96094C11.6198 4.64323 12.0217 4.40625 12.492 4.25C12.9732 4.08333 13.4982 4 14.0669 4C14.6137 4 15.1003 4.01302 15.5269 4.03906C15.9534 4.0651 16.2323 4.09375 16.3635 4.125V6.65625H14.7887C14.1653 6.65625 13.7634 6.78385 13.5829 7.03906C13.4025 7.29427 13.3122 7.625 13.3122 8.03125V9.84375H16.2651L15.8714 12.6875H13.3122V20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.ff10f1b86ff58c9c7dc38e90a5dd8cf5.svg";
export { ForwardRef as ReactComponent };